import type { SVGProps } from "react";
export default function SvgMilestone(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-milestone-icon lucide-milestone"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 13v8" />
			<path d="M12 3v3" />
			<path d="M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z" />
		</svg>
	);
}
